module.exports = __webpack_public_path__ + "img/desktop-elbow-2_60x86.dab0bf61.png";